import { IMAGE_CDN_URL } from '../../utilities/imageCDN';

export const PREGNANCY_SECTION_KEYS = [
    'firstTrimester',
    'secondTrimester',
    'thirdTrimester',
    'maternityLeave',
    'backToWork',
];

export const PREGNANCY_SECTION_MAP = {
    firstTrimester: {
        title: 'Conception & First Trimester',
        image: `${IMAGE_CDN_URL}/v1574443302/SVGs/Pregnancy_Test.svg`,
        key: 'FIRST_TRIMESTER',
        hash: 'firstTrimester',
    },
    secondTrimester: {
        title: 'Second Trimester',
        image: `${IMAGE_CDN_URL}/v1574443302/SVGs/Mommies.svg`,
        key: 'SECOND_TRIMESTER',
        hash: 'secondTrimester',
    },
    thirdTrimester: {
        title: 'Third Trimester',
        image: `${IMAGE_CDN_URL}/v1573750666/SVGs/pregnancy_header.svg`,
        key: 'THIRD_TRIMESTER',
        hash: 'thirdTrimester',
    },
    maternityLeave: {
        title: 'Maternity Leave',
        image: `${IMAGE_CDN_URL}/v1574443302/SVGs/breastfeeding.svg`,
        key: 'MATERNITY_LEAVE',
        hash: 'maternityLeave',
    },
    backToWork: {
        title: 'Back to Work',
        image: `${IMAGE_CDN_URL}/v1574443302/SVGs/Working_mom.svg`,
        key: 'BACK_TO_WORK',
        hash: 'backToWork',
    },
};
